import { ApiConfig } from '../../../../config'
import { Task } from "../../../../models"
import { RequestThunkParameters, createRequestThunk } from "../../../../utils/request-actions-helpers/createRequestThunk";
import { toggleTaskStatusActionTypes, UpdateTaskAdditionalData } from "../tasksTypes";
import { processSingleTaskResponse } from './processTasksResponse';



export const toggleTask = (config: ApiConfig) => (taskData: UpdateTaskAdditionalData) => {
    const thunkParams: RequestThunkParameters<Task, never, UpdateTaskAdditionalData> = {
        method: 'PUT',
        requestActionTypes: toggleTaskStatusActionTypes,
        actionAdditionalData: taskData,
        processResultBeforeDispatch: (data) => {
            if(!!config.updateItem) {
                config.updateItem('')
            }

            return processSingleTaskResponse(data)
        },
        url: `${config.API_URL}/tasks/update-status?taskId=${encodeURIComponent(taskData.taskId)}`,
    }

    return createRequestThunk(thunkParams)
}